import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white mt-6 border-t border-gray-200 py-6 px-6">
      <div className="flex justify-between items-center">
        <div className="text-sm text-gray-500">
          <p className="font-primary text-gray-500">© 2025 My Data Breach Attorney. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
